import { render, staticRenderFns } from "./iconGTE2-white.vue?vue&type=template&id=3a032a5a&scoped=true&"
import script from "./iconGTE2-white.vue?vue&type=script&lang=js&"
export * from "./iconGTE2-white.vue?vue&type=script&lang=js&"
import style0 from "./iconGTE2-white.vue?vue&type=style&index=0&id=3a032a5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a032a5a",
  null
  
)

export default component.exports